import { render, staticRenderFns } from "./DeptCascaderScope.vue?vue&type=template&id=34ebd67c&scoped=true"
import script from "./DeptCascaderScope.vue?vue&type=script&lang=js"
export * from "./DeptCascaderScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ebd67c",
  null
  
)

export default component.exports